import React, { useEffect, useRef, useState } from 'react';
import useWindowDimensions from '../hooks/useDimensions';

const Welcome = () => {
    const logo = process.env.REACT_APP_LOGO_LOGIN
    const { width } = useWindowDimensions()
    return(
        <div className="flex justify-content-center flex-column align-items-center w-full mt-6">
            <div className="flex flex-row align-items-center justify-content-center mb-10 font-bold text-4xl mt-6">
                <span className="text-900">Bienvenido a Remuner Selfservices</span>
            </div>
            <div className="mb-2 text-xl mt-6 w-6">
                Aquí podrás consultar tu información y autogestionar tus procesos de generación de comprobantes, solicitudes de ausentismos y/o vacaciones, 
                entre otras muchas tareas. Para empezar, dirigete al botón del menú (<i className='pi pi-bars'/>), dale click y valida las opciones que tienes disponibles.
            </div>
            <img alt={""} loading='eager' src={logo} style={{ verticalAlign: 'middle' }} width={width > 425 ? 500 : 200} height={width > 425 ? 500 : 200}/>
        </div>
    )
}

export default Welcome